<ng-container
    *ngFor="let groupedActor of actionsByPerson; int let i = index; let firstitem = first; let lastitem = last;">
        <mobile-request-status-sendgroup-action-row [actorInSendgroup]="groupedActor" [first]="firstitem" [last]="lastitem"
            [sortingAllowed]="false" [index]="i" [itemGrouped]="true" [sendgroupStatus]="sendgroupStatus"></mobile-request-status-sendgroup-action-row>
</ng-container>